import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors';
import acuIcon from '../assets/icons/acuIcon.vue'
import acuTechnic1 from '../assets/icons/acuTechnic1.vue'
import acuTechnic2 from '../assets/icons/acuTechnic2.vue'
import acuTechnic3 from '../assets/icons/acuTechnic3.vue'
import acuTechnic4 from '../assets/icons/acuTechnic4.vue'
import tcmIcon from '../assets/icons/tcmIcon.vue'
import tongueIcon from '../assets/icons/tongueIcon.vue'
import tongueIconFragmented from '../assets/icons/tongueIconFragmented.vue'
import tongueRoundL from '../assets/icons/mtc/tongue/tongueRoundL.vue'
import tongueRoundN from '../assets/icons/mtc/tongue/tongueRoundN.vue'
import tongueRoundS from '../assets/icons/mtc/tongue/tongueRoundS.vue'
import tongueSquareL from '../assets/icons/mtc/tongue/tongueSquareL.vue'
import tongueSquareN from '../assets/icons/mtc/tongue/tongueSquareN.vue'
import tongueSquareS from '../assets/icons/mtc/tongue/tongueSquareS.vue'
import tongueTriangleL from '../assets/icons/mtc/tongue/tongueTriangleL.vue'
import tongueTriangleN from '../assets/icons/mtc/tongue/tongueTriangleN.vue'
import tongueTriangleS from '../assets/icons/mtc/tongue/tongueTriangleS.vue'

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: colors.teal, //#009688
				secondary: colors.teal.lighten5, //#e0f2f1
				alert: colors.teal.lighten2,
				//text: colors.white,
				//accent: colors.shades.white,
				accent: colors.teal.accent2
				//error: colors.red.accent3,
			},
			dark: {
				primary: colors.blue.lighten3,
			},
		},
		options: {
			customProperties: true
		}
	},
	icons: {
		values: {
			acuIcon: { // name of our custom icon
				component: acuIcon, // our custom component
			},
			acuTechnic1: { // name of our custom icon
				component: acuTechnic1, // our custom component
			},
			acuTechnic2: { // name of our custom icon
				component: acuTechnic2, // our custom component
			},
			acuTechnic3: { // name of our custom icon
				component: acuTechnic3, // our custom component
			},
			acuTechnic4: { // name of our custom icon
				component: acuTechnic4, // our custom component
			},
			tcmIcon: { // name of our custom icon
				component: tcmIcon, // our custom component
			},
			tongueIcon: {
				component: tongueIcon
			},
			tongueIconFragmented: {
				component: tongueIconFragmented
			},
			tongueRoundL: {
				component: tongueRoundL
			},
			tongueRoundN: {
				component: tongueRoundN
			},
			tongueRoundS: {
				component: tongueRoundS
			},
			tongueSquareL: {
				component: tongueSquareL
			},
			tongueSquareN: {
				component: tongueSquareN
			},
			tongueSquareS: {
				component: tongueSquareS
			},
			tongueTriangleL: {
				component: tongueTriangleL
			},
			tongueTriangleN: {
				component: tongueTriangleN
			},
			tongueTriangleS: {
				component: tongueTriangleS
			}
		},
	},
});
